import React from 'react';
export function Header() {
  return <header className="bg-warm-bg/95 backdrop-blur-sm sticky top-0 z-40 border-b border-warm-alt/50" data-id="element-161">
      <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between" data-id="element-162">
        <a href="#" className="flex items-center" data-id="element-163">
          <img src="https://cdn.magicpatterns.com/uploads/8XezKwaD9LGnpzQL9aUbLz/FEB522F3-9C04-4F3B-A005-C6C7F980373E.png" alt="Espalda Libre" className="h-20 md:h-24 w-auto object-contain" data-id="element-164" />
        </a>
        <a href="#comprar" className="hidden sm:inline-flex items-center px-5 py-2 text-sm font-medium text-white bg-sage hover:bg-sage-hover rounded-full transition-all duration-300" data-id="element-165">
          Comprar ahora
        </a>
      </div>
    </header>;
}